<script>
	function scrollToKontakt() {
		const element = document.getElementById('kontakt');
		if (element) {
			element.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}
</script>

<style>
    @keyframes slideFromTop {
        from {
            opacity: 0;
            transform: translateY(-50px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes slideFromBottom {
        from {
            opacity: 0;
            transform: translateY(50px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .animate-from-top {
        animation: slideFromTop 0.8s ease-out forwards;
    }

    .animate-from-bottom {
        animation: slideFromBottom 0.8s ease-out forwards;
    }

    @keyframes fadeInBlink {
        0% {
            opacity: 0;
        }
        40% {
            opacity: 1;
        }
        60% {
            background-color: #FFFFFF;
        }
        100% {
            opacity: 1;
        }
    }

    .animate-button {
        opacity: 0;
        animation: fadeInBlink 0.8s ease-out 0.8s forwards;
    }
</style>

<div class="w-full relative hidden md:block">
    <div class="md:hidden flux mb-20"></div>
    <img class="w-full h-auto object-contain" src="photos/IMG_5680-desktop.jpg" alt=""/>
    <div class="absolute inset-0 top-2 flex items-center">
        <div class="ml-5 md:ml-16" style="width: 35%;">
            <h1 class="flex hero-main-text text-6xl font-bold leading-tight animate-from-top">
                ...bezpečný priestor pre Vás...
            </h1>

            <h2 class="hidden md:flex hero-description-text text-xl mt-4 animate-from-bottom">
                Ponúkam pomoc a podporu vo chvíľach, keď je život ťažký a vy sa cítite stratení v smútku, vyčerpaní či v náročných vzťahoch
            </h2>

            <div class="hidden md:flex justify-center mt-10">
                <button on:click={scrollToKontakt} class="animate-button bg-primary text-white px-10 py-3 rounded-lg font-medium hover:bg-opacity-90 transition-colors duration-200 cursor-pointer" style="background-color: var(--color-primary);">
                    Objednať sa
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Mobile Hero Banner with text overlay -->
<div class="w-full md:hidden relative">
    <div class="flux mb-20"></div>
    <img class="w-full h-auto object-contain" src="photos/IMG_5680-mobile.jpg" alt=""/>
    <div class="flex" style="background-color: #8B6F47">
        <!-- Mobile text and buttong below hero banner -->
        <div class="flex flex-col ">
            <h1 class="text-6xl text-color-background mx-10 my-10 text-center">
                Bezpečný priestor pre Vás
            </h1>
            <h2 class="text-2xl mx-8 mb-6 text-color-background font-second">
                Ponúkam pomoc a podporu vo chvíľach keď je život ťažký a vy sa cítite stratený v smútku, vyčerpaní či v náročných vzťahoch
            </h2>
            <div class="flex justify-center mb-10">
                <button on:click={scrollToKontakt} class="px-6 py-3 rounded-lg font-medium hover:bg-opacity-90 transition-colors duration-200 cursor-pointer" style="background-color: #F7F3EE; color: #8B6F47;">
                    objednať sa
                </button>
            </div>
        </div>

    </div>
</div>
